import React from "react";
import { useField, useFormikContext } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import style from './datepicker.module.scss';
import parse from 'html-react-parser';

export const DatePickerField = ({ ...props }) => {
	const { setFieldValue } = useFormikContext();
	const [field] = useField(props);
	let { className } = props;
	let name = (props.field && props.field.name ? props.field.name : props.name);
	let label = props.label;
	let errorCondition = (props.form && props.form.touched[name] && props.form.errors[name] ? true : (props.errorCondition !== undefined ? props.errorCondition : false));
	let errorMessage = (props.form && props.form.errors[name] ? props.form.errors[name] : props.errorMessage);
	let autoComplete = (props.autoComplete !== undefined ? (props.autoComplete === 'off' || props.autoComplete === false ? 'off' : 'on') : 'on');
	className = (className||'').split(' ');
	className.push(style.container);
	className = className.filter((item) => item);
	return (
		<div className={className.join(' ')}>
			<label htmlFor={name}>{label}</label>
			<DatePicker
				{...field}
				{...props}
				selected={(field.value && new Date(field.value)) || null}
				todayButton="Today"
				onChange={val => {
					setFieldValue(field.name, val);
				}}
			/>
			<div className={ [style.error, (errorCondition ? style.active : '')].join(' ') }>{(errorMessage) ? parse(errorMessage) : ''}</div>
		</div>
	);
};

export default DatePickerField;